

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';
import { faChevronDown, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useSession } from 'next-auth/react';
import { useRef, useState } from 'react';
import errorMsg from '../../../../Functions/errorMsg';
import axios from 'axios';
import { ObjectId } from 'bson';
import successMsg from '../../../../Functions/successMsg';

import { BarLoader } from 'react-spinners'

export default function ReportUser({ profileUsername, closeReportBox }) {

  const { data: session, status } = useSession();

  const [pendingRequest, setPendingRequest] = useState(false);

  const reasonTextRef = useRef(null);

  const [reportReason, setReportReason] = useState('Select Reason');
  const [reportMenu, showReportMenu] = useState(false);

  function selectReportReason(e, category) {
      e.preventDefault()
      if(category === reportReason) return;
      setReportReason(category);
      showReportMenu(false)
  }

  async function submitReport() {
    if(!session) return errorMsg("Please login to submit this report");
    if(status === 'loading') return;
    if(status !== 'authenticated') return errorMsg("Please login to submit this report");
    if(!reasonTextRef) return errorMsg("There was an error submitting your report, please submit it via contact@wacoexchange.com");

    const reasonText = reasonTextRef.current.value;

    if(reasonText.length === 0) return errorMsg("Please give some details before submitting your report.");
    if(reasonText.length > 500) return errorMsg("Please use a maximum of 500 characters");

    setPendingRequest(true);

    const result = await axios.post(`${window.location.origin}/api/TFSSystem/createReport`, {
      requestingUserID: session.user.token.id,
      origin: 'Profile',
      reportedUser: profileUsername,
      reasonType: reportReason,
      message: reasonText,
    }).catch((error) => {
      errorMsg(error?.response?.data?.status || error.toString());
    })

    if(result && result.status === 200) {
      successMsg("Your report was submitted, please allow 24-48 hours for a verdict.");
      closeReportBox();
    }

    setPendingRequest(false);

  }

  return (
    <section id={styles.reportWrapper}>
        <FontAwesomeIcon onClick={closeReportBox} icon={faXmark} id={styles.exit} />
        <div id={styles.reportBox}>
          <h1>Report {profileUsername}</h1>

          <div onMouseLeave={() => showReportMenu(false)} className={styles.dropdown}>
              <button disabled={pendingRequest} style={{color: reportReason === 'Select Reason' ? '#818181' : 'black'}} onClick={(e) => { e.preventDefault(); showReportMenu(reportMenu ? false : true) } } className={styles.dropdownBtn}>{reportReason} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
              <div style={{ height: 'auto', display: reportMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                  <button onClick={(e) => selectReportReason(e, "Inappropriate Content")}>Inappropriate Content</button>
                  <button onClick={(e) => selectReportReason(e, "Spam or Scams")}>Spam or Scams</button>
                  <button onClick={(e) => selectReportReason(e, "Safety Concerns")}>Safety Concerns</button>
                  <button onClick={(e) => selectReportReason(e, "Illegal Activity")}>Illegal Activity</button>
                  <button onClick={(e) => selectReportReason(e, "Privacy Violation")}>Privacy Violation</button>
                  <button onClick={(e) => selectReportReason(e, "Offensive Behavior")}>Offensive Behavior</button>
              </div>
          </div>

          <div style={{display: reportReason === 'Select Reason' ? 'none' : 'flex'}} id={styles.textBox}>
            <textarea ref={reasonTextRef} placeholder="Please give some more details about your report" maxLength={500} />
          </div>

          <button onClick={submitReport} style={{display: reportReason === 'Select Reason' ? 'none' : 'flex'}}>{ pendingRequest === true ? <BarLoader color='black' /> : "Submit Report" }</button>

        </div>
    </section>
  )
}
